import * as React from "react";
import { connect } from "react-redux";
import { selectActiveCollectEventBalancingInfo, selectActiveCollectEventIcon, selectIsCollectEventUnlocked, } from "../../selectors/selectCollectEvents";
import { EventType } from "../balancing/types/BalancingCore";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { HudButton } from "../generic/hud-button/HudButton";
import { actionPlayerLeagueSelectLeague } from "../info/league/actionPlayerLeagueInfo";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionGetCollectLeagueRanking } from "../tournament-building/actionTournament";
var _HudCollectEvent = function (_a) {
    var icon = _a.icon, onClick = _a.onClick;
    if (icon == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(HudButton, { icon: icon, onClick: onClick, showNotificationIcon: false });
};
var mapState = function (state) {
    var activeEvent = selectActiveCollectEventBalancingInfo(state);
    var activeIcon = selectActiveCollectEventIcon(state);
    var isUnlocked = selectIsCollectEventUnlocked(state);
    var eventFound = activeEvent && activeEvent.id && activeIcon;
    var shouldRender = isUnlocked && eventFound;
    return {
        icon: shouldRender ? selectActiveCollectEventIcon(state) : undefined,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () {
        dispatch(actionModalOpen(IdModal.CollectEvent));
        dispatch(actionPlayerLeagueSelectLeague(EventType.CollectLeague));
        dispatch(actionGetCollectLeagueRanking());
    },
}); };
export var HudCollectEvent = connect(mapState, mapDispatch)(HOCHudComponent(_HudCollectEvent));



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-collect-event/HudCollectEvent.tsx
// module id = 2292
// module chunks = 3